'use client';

import { useState } from 'react';

import type { AntiProfilingContent, CompareLocariTab } from '../../_content';

type DetailKey = CompareLocariTab['key'];

/**
 * Interaktive Compare-Tabs (Locari vs. andere Tools). Vollständig „dumm“: alle
 * Texte kommen als Props vom Server-Parent (AntiProfilingPage), kein i18n hier.
 */
export function CompareTabs(props: {
  eyebrow: string;
  headline: AntiProfilingContent['compareHeadline'];
  lead: string;
  locariLabel: string;
  otherLabel: string;
  otherAriaLabel: string;
  tablistAriaLabel: string;
  locariTabs: CompareLocariTab[];
  otherTabs: { num: string; label: string }[];
}) {
  const initial = props.locariTabs[0]?.key ?? 'locari-1';
  const [active, setActive] = useState<DetailKey>(initial);

  return (
    <section
      className="anti-profiling-compare"
      id="vergleich"
      aria-labelledby="compare-headline"
    >
      <div className="compare-2col">
        {/* LEFT: Body-Content (wechselt bei Tab-Click) */}
        <div className="compare-body" id="compare-body">
          <span className="eyebrow">{props.eyebrow}</span>
          <h2 className="h-display-md" id="compare-headline">
            {props.headline}
          </h2>
          <p className="lead">{props.lead}</p>

          {props.locariTabs.map((tab) => (
            <div
              key={tab.key}
              className="compare-detail"
              data-detail={tab.key}
              hidden={active !== tab.key}
            >
              <h3>{tab.title}</h3>
              <p>{tab.body}</p>
            </div>
          ))}
        </div>

        {/* RIGHT: Tab-Visual (klickbar) */}
        <div
          className="compare-tabs-card"
          role="tablist"
          aria-label={props.tablistAriaLabel}
        >
          <div className="compare-side compare-side--locari">
            <p className="compare-side-label">{props.locariLabel}</p>
            {props.locariTabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                className={
                  active === tab.key
                    ? 'compare-tab compare-tab--locari is-active'
                    : 'compare-tab compare-tab--locari'
                }
                data-target={tab.key}
                role="tab"
                aria-selected={active === tab.key}
                onClick={() => setActive(tab.key)}
              >
                <span className="step-num">{tab.num}</span> {tab.label}
              </button>
            ))}
          </div>
          <div
            className="compare-side compare-side--other"
            aria-label={props.otherAriaLabel}
          >
            <p className="compare-side-label">{props.otherLabel}</p>
            {props.otherTabs.map((tab) => (
              <div
                key={tab.num}
                className="compare-tab compare-tab--other"
                aria-hidden="true"
              >
                <span className="step-num">{tab.num}</span> {tab.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
